import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    company: [
      { name: '關於我們', href: '#about' },
      { name: '品牌故事', href: '#about' },
      { name: '門市據點', href: '#contact' },
      { name: '聯絡我們', href: '#contact' }
    ],
    products: [
      { name: '花藝作品', href: '#products' },
      { name: '熱銷推薦', href: '#products' },
      { name: '季節花卉', href: '#products' },
      { name: '客製設計', href: '#products' }
    ],
    services: [
      { name: '婚禮花藝', href: '#services' },
      { name: '企業活動', href: '#services' },
      { name: '花藝訂閱', href: '#services' },
      { name: '節慶花禮', href: '/seasonal-booking', isRoute: true }
    ],
    resources: [
      { name: '花藝生活誌', href: '#blog' },
      { name: '養護指南', href: '#blog' },
      { name: '設計靈感', href: '#blog' },
      { name: '常見問題', href: '#' }
    ]
  };

  const scrollToSection = (href: string) => {
    if (href.startsWith('#')) {
      const element = document.getElementById(href.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-gradient-to-br from-rose-50 via-pink-50 to-amber-50 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* 品牌資訊 */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-rose-400 to-pink-500 rounded-full flex items-center justify-center">
                <i className="ri-flower-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-rose-600 to-pink-600 bg-clip-text text-transparent">
                Monceau Fleurs
              </span>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              源自 1965 年巴黎的花藝美學，由美語花語引進台灣，讓每一天都能與花相伴。
            </p>
            <div className="text-xs text-gray-500 space-y-1">
              <p className="font-medium">羽天國際股份有限公司</p>
              <p>統編：90365986</p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold text-[#2C2C2C] mb-4 pb-2 border-b-2 border-[#E0E0E0]">
              花藝作品
            </h4>
            <ul className="space-y-4">
              {footerLinks.products.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-sm text-[#666666] hover:text-[#14B8A6] transition-colors cursor-pointer"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold text-[2C2C2C] mb-4 pb-2 border-b-2 border-[#E0E0E0]">
              專業服務
            </h4>
            <ul className="space-y-4">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  {'isRoute' in link && link.isRoute ? (
                    <Link
                      to={link.href}
                      className="text-sm text-[#666666] hover:text-[#14B8A6] transition-colors cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  ) : (
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="text-sm text-[#666666] hover:text-[#14B8A6] transition-colors cursor-pointer"
                    >
                      {link.name}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold text-[#2C2C2C] mb-4 pb-2 border-b-2 border-[#E0E0E0]">
              花藝資訊
            </h4>
            <ul className="space-y-4">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-sm text-[#666666] hover:text-[#14B8A6] transition-colors cursor-pointer"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-12 border-t border-[#E0E0E0]">
          <div className="mb-8 md:mb-0">
            <div className="flex items-center gap-4 mb-4">
              <img
                src="https://static.readdy.ai/image/4f3f06d226654fda02a3ba64a379f0f2/6d800fcef43fbe4ae9892fc829f784b7.jpeg"
                alt="Monceau Fleurs"
                className="h-16 w-16 object-contain rounded-lg"
              />
              <h2 className="text-5xl md:text-6xl font-extrabold text-[#1A1A2E]">
                MONCEAU
              </h2>
            </div>
            <p className="text-sm text-gray-600 mb-3">法式花藝美學 · 優雅生活品味</p>
            <p className="text-xs text-gray-500">由羽天國際股份有限公司營運</p>
          </div>

          <div className="text-center md:text-right">
            <div className="text-sm text-gray-500 mb-4">© 2025 Monceau Fleurs Taiwan. 版權所有</div>
            <div className="flex items-center space-x-5 justify-center md:justify-end mb-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-6 h-6 flex items-center justify-center text-[#666666] hover:text-[#14B8A6] transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a
                href="https://www.instagram.com/monceautaiwan/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-6 h-6 flex items-center justify-center text-[#666666] hover:text-[#14B8A6] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill text-2xl"></i>
              </a>
              <a
                href="https://line.me"
                target="_blank"
                rel="noopener noreferrer"
                className="w-6 h-6 flex items-center justify-center text-[#666666] hover:text-[#14B8A6] transition-colors cursor-pointer"
              >
                <i className="ri-line-fill text-2xl"></i>
              </a>
            </div>
            <div className="mt-4">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-gray-400 hover:text-[#14B8A6] transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
